export default __webpack_public_path__ + "static/media/brake-fast.b82cda38.png";